module.exports = "/_next/static/images/empresarial-982082501a52aa5f772801d0f3ec7149.svg";